module.exports = __webpack_public_path__ + "img/theme.f594ded3.jpg";